export function makeID(length, type) {
    let t = type || 'default';
    let characters;
    switch (t) {
        case 'numbers':
            characters = '0123456789';
            break;
        case 'caps':
            characters = 'ABCDEFGHJKLMNPQRSTUVWXYZ';
            break;
        case 'lowercase':
            characters = 'abcdefghijkmnopqrstuvwxyz';
            break;
        case 'letters':
            characters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz';
            break;
        default:
            characters = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789';
    }
    let result = '';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}